import { plainToClass } from "class-transformer";
import { JsonItem, AppUserRedacted, PickListItem, RevamppCenter, ListInformation } from "../../../../secure/list-management/scripts/list-management.objects";
import { EditController } from "../../../list-management/scripts/list-management.controllers";
import { Section, SectionField } from "../../../list-management/scripts/list-management.form-sections";
import { getDisplayDate } from "../../../../shared/scripts/date-functions";

export class ProjectManagerCenterPage {
    centerList: RevamppCenter[];
    pickLists: JsonItem[];

    editModalId: string;
    centerEditController: EditController;
    currentListController: any;

    pmCenterContainer: JQuery<HTMLElement>;

    constructor(centerList: any, pickLists: any) {
        $(() => {
            this.centerList = plainToClass(RevamppCenter, <RevamppCenter[]>centerList);
            this.centerList.sort((x1, x2) => x1.CenterName.localeCompare(x2.CenterName));
            this.pickLists = plainToClass(JsonItem, <JsonItem[]>pickLists);

            this.pmCenterContainer = $("#pm-center-content");

            this.initialize();
        });
    }

    initialize(): void {
        this.initializeEditController();
        let content = this.generateHtml();
        this.pmCenterContainer.empty().html(content);
    }

    initializeEditController(): void {
        this.currentListController = this;
        this.editModalId = "edit-item-modal";
        this.centerEditController = new EditController("pm-center-edit-controller", "Edit Center", "SaveCenters",
            [
                new Section("pm-edit-center-description", "Description",
                    [
                        new SectionField("pm-edit-center-public-description", "Public Description", "input-limit-1000", "PublicDescription", true, "", "The center's public description will be displayed on the public-facing page for this Research Center.")
                    ]
                ),
                new Section("pm-edit-center-overview", "Center Overview",
                    [
                        new SectionField("pm-edit-center-virus-family-focus", "Virus Family Focus", "multi-dropdown-pl", "VirusFamilyFocusIds", true, "pl-virus-family"),
                        new SectionField("pm-edit-center-vaccine-approach", "Vaccine Platform Approach", "multi-dropdown-pl", "VaccineApproachesIds", false, "pl-vaccine"),
                        new SectionField("pm-edit-center-antibody-approach", "Antibody Platform Approach", "multi-dropdown-pl", "AntibodyApproachesIds", false, "pl-antibody"),
                    ]
                ),
                new Section("pm-edit-center-organizations", "Participating Organizations & Institutions",
                    [
                        new SectionField("pm-edit-center-participating-orgs", "Participating Organizations", "multi-dropdown-pl-search", "ParticipatingOrgIds", false, "pl-organization-names")
                    ]
                )
            ]
            , "edit-item-modal", "CenterAbbreviation"
        )
    }

    closeAllModals() {
        $(".modal").modal('hide');
    }

    generateHtml(): string {
        let innerHtml = ``;

        this.centerList.forEach(center => {
            let content = this.generateHtmlForCenter(center);
            innerHtml += content;
        })

        let returnContent = `
            <div class="accordion" id="pm-centers-accordion">
                ${innerHtml}
            </div>
        `

        return returnContent;
    }

    generateHtmlForCenter(center: RevamppCenter): string {
        let content = `
            <div class="card accordion-item" id="center-${center.Id}">
                <div class="accordion-header collapsed" data-toggle="collapse" data-target="#collapse-${center.Id}">
                    <span class="accordion-title">${center.CenterAbbreviation}</span>
                    <span class="arrow">▼</span>
                </div>
                <div class="collapse" id="collapse-${center.Id}" data-parent="#pm-centers-accordion">
                    <div class="card-body">
                        <div class="col-12 border-bottom px-0 pb-3">
                            <div class="row justify-content-between">
                                <div class="col-auto">
                                    <div class="pm-inner-title">${center.CenterAbbreviation} | ${center.CenterName}</div>
                                    <div class="pm-innter-secondary-title">${center.OrgName}</div>
                                </div>
                                <div class="col-auto">
                                    <div class="text-right font-size15"><b>Last Updated: </b>${getDisplayDate(center.LastUpdated)}</div>
                                </div>
                            </div>            
                        </div>
                        <div class="col-12 border-bottom px-0 py-3">
                            <div class="row justify-content-between mb-3">
                                <div class="col-auto">
                                    <div class="pm-section-label">Public Description</div>
                                </div>
                                <div class="col-auto">
                                    <div class="greenbtn inner-card-btn" onclick="page.openEditModal('pm-edit-center-description', ${center.Id})">Edit Description</div>
                                </div>
                            </div>
                            <div>
                                <p>${center.PublicDescription}</p>
                            </div>
                        </div>
                        <div class="col-12 border-bottom px-0 py-3">
                            <div class="row justify-content-between mb-3">
                                <div class="col-auto">
                                    <div class="pm-section-label">Center Overview</div>
                                </div>
                                <div class="col-auto">
                                    <div class="greenbtn inner-card-btn" onclick="page.openEditModal('pm-edit-center-overview', ${center.Id})">Edit Overview</div>
                                </div>
                            </div>
                            <div class="pill-list-container mb-3">
                                <div class="pill-list-label">
                                    <span class="pill-list-icon light-blue"></span>
                                    Virus Family Focus
                                </div>
                                <div class="row">
                                    ${this.generatePillContent(center.VirusFamilyFocusIds, "pl-virus-family", "light-blue")}
                                </div>
                            </div>
                            <div class="pill-list-container mb-3">
                                <div class="pill-list-label">
                                    <span class="pill-list-icon light-green"></span>
                                    Vaccine Approaches
                                </div>
                                <div class="row">
                                    ${this.generatePillContent(center.VaccineApproachesIds, "pl-vaccine", "light-green")}
                                </div>
                            </div>
                            <div class="pill-list-container mb-3">
                                <div class="pill-list-label">
                                    <span class="pill-list-icon yellow"></span>
                                    Antibody Approaches
                                </div>
                                <div class="row">
                                    ${this.generatePillContent(center.AntibodyApproachesIds, "pl-antibody", "yellow")}
                                </div>
                            </div>
                        </div>
                        <div class="col-12 border-bottom px-0 py-3">
                            <div class="row justify-content-between mb-3">
                                <div class="col-auto">
                                    <div class="pm-section-label">Participating Organizations & Institutions</div>
                                </div>
                                <div class="col-auto">
                                    <div class="greenbtn inner-card-btn" onclick="page.openEditModal('pm-edit-center-organizations', ${center.Id})">Edit Organizations</div>
                                </div>
                            </div>
                            <div class="pill-list-container mb-3">
                                <div class="pill-list-label">
                                    <span class="pill-list-icon dark-blue"></span>
                                    Participating Organizations & Institutions
                                </div>
                                <div class="row">
                                    ${this.generatePillContent(center.ParticipatingOrgIds, "pl-organization-names", "dark-blue")}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        `
        return content;
    }

    generatePillContent(idString: string, pickList: string, color: string): string {
        if (idString == null || idString == "") {
            return "<div class='error-msg col-auto'>--Not Specified--</div>"
        }
        let foundPickList: PickListItem[] = this.pickLists.find(list => list.Id == pickList)?.Json;
        if (!foundPickList) {
            return "<div class='error-msg col-auto'>--No Pick List Found--</div>"
        }

        let idArr: string[] = idString.split("|");
        let valArr: string[] = [];
        let returnContent: string = ``;
        idArr.forEach(id => {
            let foundItem = foundPickList.find(item => item.Id.toString() == id);
            if (foundItem) {
                valArr.push(foundItem.Value);
            }
        });
        valArr.sort();
        valArr.forEach(val => {
            returnContent += `
                <div class="col-auto pr-0 mb-2">
                    <div class="pill-list-item ${color}">${val}</div>
                </div>`
        })

        if (returnContent == "") {
            return "<div class='error-msg col-auto'>--Not Specified--</div>";
        }
        return returnContent;
    }

    updateCenterDisplay(centers: RevamppCenter[]) {
        centers.forEach(center => {
            let previousCenterIndex = this.centerList.findIndex(prevCenter => prevCenter.Id == center.Id);
            if (previousCenterIndex >= 0) {
                this.centerList.splice(previousCenterIndex, 1, center);
            }
            let newContent: string = this.generateHtmlForCenter(center);
            $(`#center-${center.Id}`).replaceWith(newContent);
            $(`#center-${center.Id}`).find(".accordion-header").trigger('click');
        })
    }

    openEditModal(sectionId: string, targetId: number) {
        this.centerEditController.showLoading(false);

        let foundCenter = this.centerList.find(center => center.Id == targetId);
        if (foundCenter) {
            this.centerEditController.initialize(this.pickLists, [foundCenter], sectionId);
            $(`#${this.editModalId}`).modal('show');
        }
    }

    async saveEditModal() {
        // if it isn't valid, don't save
        let isValid = this.centerEditController.validate();
        if (!isValid) {
            return;
        }
        else {
            // show saving on edit modal
            this.centerEditController.showLoading(true);

            // saves changes to DB (returns updated items)
            let result: any[] = await this.centerEditController.save();

            // reinitialze
            this.updateCenterDisplay(result);

            // Show Saved
            this.centerEditController.showSaved(true);


            // hide loading/close modal
            setTimeout(() => {
                $(`#${this.editModalId}`).modal('hide');

                // Don't hide information until after modal finishes hiding
                setTimeout(() => {
                    this.centerEditController.showLoading(false);
                    this.centerEditController.showSaved(false);
                }, 1000)
            }, 1000)
        }
    }
}